import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Spa from './Spa'

ReactDOM.hydrate(<Spa />, document.getElementById('root'))
